module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_02-883d52399b806ff8407ef4f6608095a6.svg";